import React, { useEffect, useState, useContext } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import {
  getAllTransferData,
  TransferRejected,
} from "../../../../utils/apis/Transfer/transfer";
import { formatDate } from "../../../../utils/common";
import Pagination from "../../../common/Pagination";
import ExportMethod from "../../../../utils/apis/ExportMethod";
import { Context } from "../../../../utils/context";
import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
import Filter_offcanvas from "../../../common/common-offcanvas/Filter_offcanvas";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { ShimmerButton, ShimmerTable } from "react-shimmer-effects";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getSetup } from "../../../../utils/apis/masters/masters";
const Reports = ({
  status,
  setStatus,
  handleExportCSV,
  handlePrint,
  handleExportExcel,
}) => {
  const {
    register,
    handleSubmit,
    getValues,
    reset,
    setValue,
    control,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    alert(JSON.stringify(data));
  };
  const { IMG_URL, isAllow, shimmerLoader, setShimmerLoader } =
    useContext(Context);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [TotalEntries, setTotalEntries] = useState(1);
  const [TotalPages, setTotalPages] = useState(1);
  const [perPage, setperPage] = useState(10);

  const getData = async () => {
    setShimmerLoader(true);
    const res = await getAllTransferData(
      currentPage,
      perPage,
      getValues("contact"),
      getValues("name"),
      getValues("from"),
      getValues("to"),
      getValues("state_id")?.value,
      getValues("city_id")?.value,
    );
    setData(res.data);
    setCurrentPage(res?.data?.currentPage);
    setperPage(res?.data?.per_page);
    setTotalEntries(res?.data?.totalEntries);
    setTotalPages(res?.data?.totalPages);
    setShimmerLoader(false);
  };

  const Rejected = async (id) => {
    const data = {
      id: id,
      accepted_rejected: 0,
    };

    const res = await TransferRejected(data);
    if (res.success) {
      getData();
    }
  };

  useEffect(() => {
    getData();
  }, [perPage, currentPage, status]);

  const [modalShow2, setModalShow2] = React.useState(false);

  const [setup, setSetup] = useState([]);
  const getMastersData = async () => {
    const res = await getSetup();
    await setSetup(res?.data);
  };

  useEffect(() => {
    getMastersData();
  }, []);
  const convertrate = (amount) => {
    const inr = Number(amount);
    const rate = Number(setup?.withdraw_exchange_rate);
    const total = (inr * rate).toFixed(2);
    return total;
  };
  return (
    <div className="search-investor mt-4">
      <p className="sub">Report</p>
      <div className="inward-payment">
        {isAllow?.includes(47) ? (
          <div className="nav-link active">
            <div className="dt-buttons btn-group flex-wrap">
              <button
                className="btn btn-secondary buttons-excel buttons-html5 ml-1 Excel_btn"
                tabindex="0"
                aria-controls="DataTables_Table_0"
                type="button"
                onClick={() => handleExportExcel(data, "Transfer")}
              >
                <span>Excel</span>
              </button>
              <button
                className="btn btn-secondary buttons-csv buttons-html5 CSV_btn"
                tabindex="0"
                aria-controls="DataTables_Table_0"
                type="button"
                onClick={() => handleExportCSV(data, "Transfer")}
              >
                <span>CSV</span>
              </button>
              <button
                className="btn btn-secondary buttons-print Print_btn"
                tabindex="0"
                aria-controls="DataTables_Table_0"
                type="button"
                onClick={() => handlePrint(data, "Transfer")}
              >
                <span>Print</span>
              </button>

              <input
                type="number"
                className="ps-3"
                onChange={(e) => setperPage(e.target.value)}
                placeholder="Enter Per Page Data"
              ></input>
            </div>
          </div>
        ) : (
          <></>
        )}

        <div className="filterdiv">
          <button onClick={() => setModalShow2(true)} className="filterbtn">
            <FontAwesomeIcon icon={faFilter} />
            &nbsp;Filter
          </button>
        </div>
      </div>
      {/* table started */}
      <div className="table-main">
        <div className="table-responsive mt-2">
          {shimmerLoader ? (
            <>
              <ShimmerTable row={2} col={9} width={100} />
            </>
          ) : (
            <table className="table table-bordered  table-striped">
              <thead>
                <tr>
                  <th className="name">
                    Payment Date
                    <div className="triangle"></div>
                    <div className="triangle2"></div>
                  </th>
                  <th className="name">
                    Investor Name
                    <div className="triangle"></div>
                    <div className="triangle2"></div>
                  </th>
                  <th className="name">
                    Service No
                    <div className="triangle"></div>
                    <div className="triangle2"></div>
                  </th>
                  <th className="name">
                    State
                    <div className="triangle"></div>
                    <div className="triangle2"></div>
                  </th>
                  <th className="name">
                    District
                    <div className="triangle"></div>
                    <div className="triangle2"></div>
                  </th>

                  <th className="name">
                    A/C No
                    <div className="triangle"></div>
                    <div className="triangle2"></div>
                  </th>
                  <th className="name">
                    IFSC Code
                    <div className="triangle"></div>
                    <div className="triangle2"></div>
                  </th>

                  <th className="name">
                    Withdrawal Amount
                    <div className="triangle"></div>
                    <div className="triangle2"></div>
                  </th>
                  <th className="name">
                    Payment Type
                    <div className="triangle"></div>
                    <div className="triangle2"></div>
                  </th>

                  {/* <th className="name">
                  Action
                  <div className="triangle"></div>
                  <div className="triangle2"></div>
                </th> */}

                  {/* <th className="name">
                  Total Amount
                  <div className="triangle"></div>
                  <div className="triangle2"></div>
                </th> */}
                  {/* <th className="name">
                  Action
                  <div className="triangle"></div>
                  <div className="triangle2"></div>
                </th> */}
                </tr>
              </thead>
              <tbody>
                {data?.data?.map((data, index) => (
                  <tr className="odd" key={index}>
                    <td>{formatDate(data?.updatedAt)}</td>
                    <td>
                      {data?.user?.f_name} {data?.user?.l_name}
                    </td>
                    <td>{data?.user?.contact_no}</td>
                    <td>{data?.user?.users_detail?.state?.name}</td>
                    <td>{data?.user?.users_detail?.city?.name}</td>
                    <td>{data?.ac_no || "-"}</td>
                    <td>{data?.ifsc_code || "-"}</td>
                    <td>{convertrate(data?.amount)}</td>
                    <td>{data?.withdrawn_type}</td>
                    {/* <td>
                      {" "}
                      <Button
                        onClick={()=> Rejected(data?.id)}
                        type="button"
                        className="btn btn-primary me-1 mt-5"
                      >
                        Cancel
                      </Button>
                    </td> */}
                    {/* <td>{data?.accepted_rejected ? "Accepted" : "Rejected"}</td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
      {/* table ended */}
      <Pagination
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        TotalPages={TotalPages}
        TotalEntries={TotalEntries}
        perPage={perPage}
      />
      {["end"].map((placement, idx) => (
        <Filter_offcanvas
          placement={placement}
          key={idx}
          show={modalShow2}
          onHide={() => setModalShow2(false)}
          setValue={setValue}
          getValues={getValues}
          getData={getData}
          register={register}
          reset={reset}
          control={control}
        />
      ))}
    </div>
  );
};

export default Reports;
